import axios from "axios";

export const saveEmailSchedule = async (payload) => {
    return axios.post('api/email/add-update-schedule', payload).catch((e) => { console.log(e) });
};

export const getEmailSchedules = async (compId) => {
    let response = await axios.get(`api/email/get-email?company=${compId}`);
    return response.data || [];
};
export const getEmailHistory = async (payload) => {
    let response = await axios.post(`api/email/get-email-history`, payload);
    return response.data || [];
};
export const getEmailAddresses = async companyId => {
    let response = await axios.get(`api/email/email-addresses/${companyId}`);
    return response.data || [];
};

export const deleteEmailSchedule = async (emailId) => {
    return axios.delete(`api/email/delete/${emailId}`).catch((e) => { console.log(e) });
};

export const documentDownload = async (payload) => {

    let response = await axios.post(`api/email/document-download`, payload, { responseType: "blob" });
    return response.data || [];
}